export enum ErrorCode {
  LoginInvalidCredentials = "loginInvalidCredentials",
  LoginInvalidCredentialsTotp = "loginInvalidCredentialsTotp",
  LoginInactiveUser = "LoginInactiveUser",
  PatientAccountInvalidCredentials = "PatientAccountInvalidCredentials",
  PatientAccountInvalidCredentialsMfa = "PatientAccountInvalidCredentialsMfa",
  PatientAccountEmailAlreadyInUse = "PatientAccountEmailAlreadyInUse",
  PatientAccountLoginAttemptsExceeded = "PatientAccountLoginAttemptsExceeded",
  PatientAccountPasswordResetExpired = "PatientAccountPasswordResetExpired",
  PatientAccountLoginExpired = "PatientAccountLoginExpired",
  PatientAccountSmsAttemptsExceeded = "PatientAccountSmsAttemptsExceeded",
  PatientAccountSmsIncorrectCode = "PatientAccountSmsIncorrectCode",
  PatientAccountDuplicateEmail = "PatientAccountDuplicateEmail",
  RegistrationClosed = "RegistrationClosed",
  RegistrationAlreadyCreated = "RegistrationAlreadyCreated",
  RegistrationRequestExistingPatient = "RegistrationRequestExistingPatient",
  // Staff-created registration: the matched person already has an active
  // (Undecided) registration request or an active patient in this practice.
  RegistrationRequestDuplicateActive = "RegistrationRequestDuplicateActive",
  RegistrationRequestAcceptedHisKnown = "RegistrationRequestAcceptedHisKnown",
  RegistrationRequestCompletedHisUnknown = "RegistrationRequestCompletedHisUnknown",
  ReregistrationHisUnknown = "ReregistrationHisUnknown",
  RegistrationHisFailed = "RegistrationHisFailed",
  AppointmentCreationClosed = "AppointmentCreationClosed",
  WalkInConsultCreationClosed = "WalkInConsultCreationClosed",
  WalkInConsultCreationQueueFull = "WalkInConsultCreationQueueFull",
  IdentificationCheckError = "IdentificationCheckError",
  NoAgendaConfigured = "NoAgendaConfigured",
  HISLogout = "HISLogout",
  DuplicatePassword = "DuplicatePassword",
  PatientBSNAlreadyExists = "PatientBSNAlreadyExists",
  PatientBSNInvalid = "PatientBSNInvalid",
  CommunicationLogAccessDenied = "CommunicationLogAccessDenied",
  // Expected when a (time-limited) practice authorization expired or was
  // revoked while the frontend was still open — suppressed from warn-logs
  // and Sentry in `AllExceptionsFilter`.
  PracticeConfigurationAccessDenied = "PracticeConfigurationAccessDenied",
  UsernameAlreadyInUse = "UsernameAlreadyInUse",
  ExistingPracticeAuthorization = "ExistingPracticeAuthorization",
  ExistingCareGroupAuthorization = "ExistingCareGroupAuthorization",

  MfaSessionNotFound = "mfaSessionNotFound",
  MfaInvalidToken = "mfaInvalidToken",
  MfaSessionExpired = "mfaSessionExpired",
  MfaMaxAttemptsReached = "mfaMaxAttemptsReached",
  MfaContextMismatch = "mfaContextMismatch",
  MfaCallNotAllowed = "mfaCallNotAllowed",
  MfaDeliveryCooldown = "mfaDeliveryCooldown",
  MfaDeliveryFailed = "mfaDeliveryFailed",

  // Page invitation errors
  InvitationRecipientMismatch = "InvitationRecipientMismatch",
  InvitationNotRedeemable = "InvitationNotRedeemable",

  // User invitation errors
  DuplicateUserInvitation = "DuplicateUserInvitation",
  InvitationAccountAlreadyExists = "InvitationAccountAlreadyExists",
  EmailDomainBlocked = "EmailDomainBlocked",
  EmailNotDeliverable = "EmailNotDeliverable",

  // File import errors
  UnsupportedImportFile = "UnsupportedImportFile",

  // File upload errors
  FileContentTypeNotAllowed = "FileContentTypeNotAllowed",
  FileTooLarge = "FileTooLarge",
  ImageDimensionsTooLarge = "ImageDimensionsTooLarge",
  ImageProcessingFailed = "ImageProcessingFailed",

  // Plato errors we can handle (see `PlatoErrorType`)
  NOT_CURRENT_QUESTION = "NOT_CURRENT_QUESTION",
}
